import React, { useState } from "react";
import { SubDone } from "../../../assets/icons/SubDone";
import { formatMoney } from "../../../utils";
import { CloseIcon } from "../../../assets/icons";
import { useNavigate } from "react-router-dom";
import { createSubscriptionPaymentLink } from "../../../backend-services/subscription";

const SubscriptionPrices = [
  {
    title: "Free",
    features: [
      "10 Invoices",
      "10 Expenses",
      "5 Inventories",
      "3 Services",
      "Unlimited customers",
      "Unlimited Report",
      "Dashboard and Analytics",
      "24/7 Online support",
    ],
    price: "0",
    plans: "Current Plan",
    bgColor: "#E0E0E0",
    plan: "free",
  },
  {
    title: "Essential",
    features: [
      "30 Invoices",
      "30 Expenses",
      "20 Inventories",
      "10 Services",
      "10 Invoice payment upload",
      "Unlimited Report",
      "Weekly Report",
      "Payment Integration",
      "User Management (3 Users)",
      "Unlimited Customers",
      "Customized Invoice Template",
      "Dashboard and Analytics",
      "24/7 Online support",
    ],
    subPrice: 5000,
    price: 2500,
    plans: "Upgrade to essential plan",
    bgColor: "#FF6702",
    plan: "essential",
  },
  {
    title: "Premium",
    features: [
      "100 Invoices",
      "200 Expenses",
      "Unlimited Inventory",
      "Service Management",
      "50 Invoice payment upload",
      "50 Expenses AI automation",
      "Unlimited Report",
      "Weekly Report",
      "Payment Integration",
      "User Management (6 Users)",
      "Unlimited Customers",
      "Customized Invoice Template",
      "Dashboard and Analytics",
      "24/7 Online support",
    ],
    price: 4500,
    subPrice: 9000,
    plans: "Upgrade to Premium plan",
    bgColor: "#044E97",
    plan: "premium",
  },
];

interface DesktopSubscriptionModalProps {
  onClose: () => void;
  titleText: string;
  subtitleText: string;
}

const DesktopSubscriptionModal: React.FC<DesktopSubscriptionModalProps> = ({
  onClose,
  titleText,
  subtitleText,
}) => {
  const navigate = useNavigate();
  const [showPlanDetailsModal, setShowPlanDetailsModal] = useState(false);
  const [plan, setPlan] = useState<string>("");
  const [subscriptionId, setSubscriptionId] = useState<number>(0);
  const [price, setPrice] = useState<number>(0);

  const handleHideModal = () => {
    setShowPlanDetailsModal(false);
  };

  const callbackUrl = `${window.location.href}/processing`;

  const handlePaymentSucess = async (plan: string) => {
    try {
      const data = await createSubscriptionPaymentLink({
        paymentProvider: "paystack",
        plan: plan,
        callback_url: callbackUrl,
      });
      const { authorization_url } = data;
      window.location = authorization_url;
    } catch (error: any) {
      throw new Error(error);
    }
  };

  return (
    <div className="p-[32px] bg-[#ffffff] rounded-[16px] max-h-screen w-[90%] xl:max-h-[748px] xl:w-[946px] 2xl:w-[1046px] overflow-y-auto">
      <div className="text-[#212121] mb-[48px]">
        <div className="flex items-center justify-between">
          <p className="text-[32px] font-semibold">{titleText}</p>
          <button onClick={onClose}>
            <CloseIcon />
          </button>
        </div>
        <p className="font-medium text-[20px]">{subtitleText}</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-1">
        {SubscriptionPrices.map((subscription, i) => (
          <div key={i}>
            <div className="pt-[32px] pb-[24px] px-[24.5px] shadow-xl text-center rounded-[16px]">
              <div className="flex items-center justify-center">
                <SubDone />
                <p className="text-[20px] text-[#979797]">
                  <span className="font-bold text-[#2B2B2B]">
                    {subscription.title}
                  </span>{" "}
                  Plan
                </p>
              </div>
              <div className="my-[48px] rounded-[16px] min-h-[240px]">
                <ul className="space-y-[23px] text-[16px] font-normal text-[#2B2B2B] text-start">
                  {subscription.features.map((feature, j) => (
                    <li key={j} className="flex items-center gap-[25px]">
                      <svg
                        width="19"
                        height="19"
                        viewBox="0 0 19 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M9.5 19C14.7467 19 19 14.7467 19 9.5C19 4.25329 14.7467 0 9.5 0C4.25329 0 0 4.25329 0 9.5C0 14.7467 4.25329 19 9.5 19Z"
                          fill="white"
                        />
                        <path
                          d="M9.5 18.5C14.4706 18.5 18.5 14.4706 18.5 9.5C18.5 4.52944 14.4706 0.5 9.5 0.5C4.52944 0.5 0.5 4.52944 0.5 9.5C0.5 14.4706 4.52944 18.5 9.5 18.5Z"
                          stroke="#5064CC"
                        />
                        <path
                          d="M4.5 10.0498L7.23633 13.2349L14.1816 6.5"
                          stroke="#5064CC"
                        />
                      </svg>
                      <p>{feature}</p>
                    </li>
                  ))}
                </ul>
              </div>
              <p className="mb-[24px] text-[20px] xl:text-[30px] font-semibold text-center">
                {formatMoney(subscription.price)}
                <span className="lg:text-[14px]  line-through pl-2 text-[#979797]">
                  {" "}
                  {formatMoney(subscription.subPrice)}
                </span>
                <span className="text-[#979797] text-[16px]">
                  {i === 0 ? "" : "/month"}
                </span>
              </p>
              <button
                style={{ backgroundColor: subscription.bgColor }}
                className={`text-center h-[48px] w-full rounded-[4px] text-[16px] font-semibold ${
                  i === 0 ? "text-[#828282]" : "text-[#ffffff]"
                }`}
                onClick={() => handlePaymentSucess(subscription.plan)}
              >
                {subscription.plans}
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DesktopSubscriptionModal;
